import { render } from "./Banner.vue?vue&type=template&id=f32f877a&scoped=true"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=f32f877a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32f877a"]])

export default __exports__